import { Link } from 'react-router-dom';

import { InformationBox, Text } from '@pukka/ui-components';

import { BillingDiscountReminder } from '../BillingDiscountReminder';
import { BillingRecurringReminder } from '../BillingRecurringReminder';
import { ReminderDetail } from '../Layout/utils/getBillingReminderDetail';

interface BillingReminderProps {
  readonly isOwner?: boolean;
  readonly businessId?: number;
  readonly expiredAt?: string;
  readonly onCloseBanner?: (type: ReminderDetail['type']) => void;
}

function BillingReminder({ type, text, isOwner, businessId, expiredAt, onCloseBanner }: BillingReminderProps & ReminderDetail) {
  const handleCloseBanner = () => {
    if (onCloseBanner) {
      onCloseBanner(type);
    }
  };

  switch (type) {
    case 'expired':
      return (
        <InformationBox variant="danger" icon="terms-and-conditions" className="rounded-none p-3">
          <Text variant="caption-2">
            Renew Your MOKA Subscription for Ongoing Business Assistance – <strong>Your Current Subscription Has Expired.</strong>
          </Text>
        </InformationBox>
      );
    case 'discount':
      return <BillingDiscountReminder isBanner show={isOwner} businessId={businessId} expiredAt={expiredAt} onClose={handleCloseBanner} />;
    case 'recurring':
      return <BillingRecurringReminder isBanner onClose={handleCloseBanner} />;
    default:
      return (
        <div role="alert" className="z-20 flex h-[40px] justify-between bg-yellow-100 px-7 py-3 text-xs">
          <div>
            <strong>{text}</strong>
          </div>
          <div>
            <Link
              to="/v2/settings/billing"
              className={isOwner ? 'h-[30px] border bg-white px-2 py-1 text-light-blue-400' : 'pointer-events-none text-red-400'}
            >
              <strong>Subscribe Now</strong>
            </Link>
          </div>
        </div>
      );
  }
}

export { BillingReminder };
